module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-dusty-rose-1-8eab7ae033d5ff5ac59334b22ae5da67.png";